import { withTranslation, WithTranslation } from 'react-i18next';
import { Button, Form, Checkbox, Dimmer, Loader, Icon, Divider, Dropdown } from 'semantic-ui-react';
import React, { Component } from 'react';
import { connect } from 'redux-scaffolding-ts';
import { IdentityService, Roles } from 'services/identity-service';
import { Query } from 'stores/dataStore';
import { resolve } from 'inversify.config';
import {
  EventCheckListRoleUserStore,
  eventCheckListRoleUserDto,
  eventCheckListRoleUserCheck,
  NewEventCheckListRoleUserStore,
  ChangeEventCheckListRoleUserStore,
  EventCheckListRoleUserStoreNew,
  EventCheckListRoleUserNewGroupDto,
  EventCheckListRoleUserNewItemDto,
  UpdateEventCheckListRoleUserNewItemDto,
  EventChecklistUploadedFileDto,
  uploadEventChecklistUserFile,
  ChecklistRoleUserFileService
} from 'stores/events/event-checkList-roleuser-store';
import { downloadChecklistFileAs, isValidChecklistExcelFile } from 'stores/configuration/events-n-requests/checklists-store';
import { EventTypeChecklistTemplateDto, EventTypeChecklistTemplateStore } from 'stores/events/event-type-checklist-template-store';
import LocationEditorWithRoleLocations from 'widgets/bussiness/location-editor-with-rolelocations';
import './check-list-tab-pane.less';
import { EventFormStore } from 'stores/events/event-form-store';
import { ToastComponent } from 'site/pages/landing-pages/util/toast-component';
import EventService from 'stores/events/event-service';

interface InstructorCheckListViewModel extends EventCheckListRoleUserNewItemDto {
  description: string;
  isMandatory: boolean;
}

interface ChecklistTemplateFileViewModel {
  originalName: string;
  uploadedName: string;
}

interface CheckListTabPaneProps extends WithTranslation {
  eventFormStore?: EventFormStore;
  eventchecklistsroleuser?: EventCheckListRoleUserStore;
  neweventchecklistsroleuser?: NewEventCheckListRoleUserStore;
  changeeventchecklistsroleuser?: ChangeEventCheckListRoleUserStore;
  eventchecklistsroleusernew?: EventCheckListRoleUserStoreNew;
  eventTypeChecklistTemplateStore?: EventTypeChecklistTemplateStore;
  readOnly?: boolean;
}

export interface CheckListTabState {
  query: Query;
  isUpdate: boolean;
  hasPocManyLocations: boolean;
  showSaveCheckListButton: boolean;
  showSaveInstructorCheckListButton: boolean;
  showLegacyCheckList: boolean;
  roleLocation: string;
  loading: boolean;
  selectedInstructorId: string | null;
  instructorCheckListGroups: EventCheckListRoleUserNewGroupDto[];
  savedInstructorCheckListGroups: EventCheckListRoleUserNewGroupDto[];
  modifiedInstructorIds: Set<string>;
  expandedItems: Set<number>;
  eventChecklistFiles: EventChecklistUploadedFileDto[];
  confirmedEventChecklistFiles: EventChecklistUploadedFileDto[];
  removedEventChecklistFiles: EventChecklistUploadedFileDto[];
  otherInstructorsChecklistFiles: EventChecklistUploadedFileDto[];
  uploadingEventChecklistFile: boolean;
  eventTypeTemplate: EventTypeChecklistTemplateDto | null;
  templateEventTypeId: string | null;
  loadingEventTypeTemplate: boolean;
  downloadingEventTypeTemplate: boolean;
}

@connect(
  ['eventFormStore', EventFormStore],
  ['eventchecklistsroleuser', EventCheckListRoleUserStore],
  ['neweventchecklistsroleuser', NewEventCheckListRoleUserStore],
  ['changeeventchecklistsroleuser', ChangeEventCheckListRoleUserStore],
  ['eventchecklistsroleusernew', EventCheckListRoleUserStoreNew],
  ['eventTypeChecklistTemplateStore', EventTypeChecklistTemplateStore]
)
class CheckListTabPane extends Component<CheckListTabPaneProps, CheckListTabState> {
  private templateRequestId = 0;
  private otherFilesRequestId = 0;

  constructor(props: Readonly<CheckListTabPaneProps>) {
    super(props);
    const event = this.props.eventFormStore.state.item;

    let query: Query = { searchQuery: '', orderBy: [], skip: 0, take: 10 };
    const currentUserInfo = this.identityService.getUserInfo();
    let hasPocManyLocations: boolean = false;
    let roleLocation: string = '';
    let searchQuery: string = '';
    if (IdentityService.isPoc(currentUserInfo)) {
      const pocLocations = currentUserInfo.locationsByRoles[currentUserInfo.activeRole] as string[];
      let eventRelatedLocationIds = this.getEventRelatedLocationIds();
      let locations = pocLocations.filter(x => eventRelatedLocationIds.includes(x));

      hasPocManyLocations = locations.length > 1;
      roleLocation = locations[0];
      searchQuery = "role eq 'PoC' and LocationId eq " + roleLocation + '  and EventId eq ' + event.id;
    }
    if (IdentityService.isInstructor(currentUserInfo)) {
      searchQuery = "role eq 'Instructor' and UserId eq " + currentUserInfo.userId + ' and EventId eq ' + event.id;
    }
    if (IdentityService.isPlannerTFT(currentUserInfo)) {
      searchQuery = "role eq 'Planner' and EventId eq " + event.id;
    }
    if (IdentityService.isPlannerMTC(currentUserInfo)) {
      searchQuery = "role eq 'Planner MTC' and EventId eq " + event.id;
    }
    if (IdentityService.isWorker(currentUserInfo)) {
      searchQuery = "role eq 'Employee' and UserId eq " + currentUserInfo.userId + ' and EventId eq ' + event.id;
    }
    if (IdentityService.isAdmin(currentUserInfo)) {
      searchQuery = 'EventId eq ' + event.id;
    }

    const filter = searchQuery;

    query = Object.assign(query, { filter, skip: 0 });

    this.state = {
      query,
      isUpdate: false,
      roleLocation,
      hasPocManyLocations,
      showSaveCheckListButton: false,
      showSaveInstructorCheckListButton: false,
      showLegacyCheckList: false,
      loading: false,
      selectedInstructorId: null,
      instructorCheckListGroups: [],
      savedInstructorCheckListGroups: [],
      modifiedInstructorIds: new Set(),
      expandedItems: new Set(),
      eventChecklistFiles: [],
      confirmedEventChecklistFiles: [],
      removedEventChecklistFiles: [],
      otherInstructorsChecklistFiles: [],
      uploadingEventChecklistFile: false,
      eventTypeTemplate: null,
      templateEventTypeId: null,
      loadingEventTypeTemplate: true,
      downloadingEventTypeTemplate: false
    };
  }

  @resolve(IdentityService)
  private identityService: IdentityService;

  @resolve(EventService)
  private eventService: EventService;

  componentDidMount() {
    this.load();
    this.loadInstructorCheckLists();
    this.loadEventChecklistFiles();
    this.loadOtherInstructorsChecklistFiles();
    this.loadEventTypeTemplate();
  }

  componentDidUpdate() {
    const eventTypeId = this.props.eventFormStore.state.item.eventType?.id || null;
    if (eventTypeId !== this.state.templateEventTypeId) this.loadEventTypeTemplate();
  }

  componentWillUnmount() {
    this.templateRequestId++;
  }

  private async loadEventTypeTemplate() {
    const eventTypeId = this.props.eventFormStore.state.item.eventType?.id || null;
    const requestId = ++this.templateRequestId;
    this.setState({ templateEventTypeId: eventTypeId, eventTypeTemplate: null, loadingEventTypeTemplate: !!eventTypeId });
    if (!eventTypeId) return;

    try {
      const template = await this.props.eventTypeChecklistTemplateStore.getByEventTypeId(eventTypeId);
      if (requestId === this.templateRequestId) {
        this.setState({ eventTypeTemplate: template, loadingEventTypeTemplate: false });
      }
    } catch {
      if (requestId === this.templateRequestId) {
        this.setState({ eventTypeTemplate: null, loadingEventTypeTemplate: false });
      }
    }
  }

  private getEventChecklistFileOwner() {
    const user = this.identityService.getUserInfo();
    const instructors = this.props.eventFormStore.state.item.instructors || [];
    const instructorId =
      this.state.selectedInstructorId ||
      (IdentityService.isInstructor(user) ? user.userId : IdentityService.isAdmin(user) ? instructors[0]?.user?.id : undefined);

    return instructorId ? { role: 'Instructor', userId: instructorId } : { role: user.activeRole, userId: user.userId };
  }

  private async loadEventChecklistFiles(instructorId?: string) {
    const event = this.props.eventFormStore.state.item;
    const fileOwner = instructorId ? { role: 'Instructor', userId: instructorId } : this.getEventChecklistFileOwner();

    try {
      const result = await ChecklistRoleUserFileService.getEventFiles(event.id, fileOwner.role, fileOwner.userId, null);
      const files = result.data.items || result.data.item || [];
      this.setState({ eventChecklistFiles: files, confirmedEventChecklistFiles: files });
    } catch {
      this.setState({ eventChecklistFiles: [], confirmedEventChecklistFiles: [] });
    }
  }

  // Read-only list of files uploaded by the instructors other than the current owner (the logged instructor, or the one
  // selected by Admin). Kept apart from eventChecklistFiles so upload/remove/save flows never touch them.
  private async loadOtherInstructorsChecklistFiles(ownerInstructorId?: string) {
    const user = this.identityService.getUserInfo();
    if (!IdentityService.isInstructor(user) && !IdentityService.isAdmin(user)) return;

    const requestId = ++this.otherFilesRequestId;
    const event = this.props.eventFormStore.state.item;
    const ownerId = ownerInstructorId || this.getEventChecklistFileOwner().userId;
    const otherInstructors = (event.instructors || [])
      .map(instructor => instructor.user)
      .filter((u, index, users) => u?.id && u.id !== ownerId && users.findIndex(x => x?.id === u.id) === index);

    if (otherInstructors.length === 0) {
      this.setState({ otherInstructorsChecklistFiles: [] });
      return;
    }

    const results = await Promise.allSettled(
      otherInstructors.map(async instructor => {
        const result = await ChecklistRoleUserFileService.getEventFiles(event.id, 'Instructor', instructor.id, null);
        const files = result.data.items || result.data.item || [];
        return files.filter(file => file.id && file.userId !== ownerId);
      })
    );

    if (requestId !== this.otherFilesRequestId) return;
    this.setState({
      otherInstructorsChecklistFiles: results.flatMap(result => (result.status === 'fulfilled' ? result.value : []))
    });
  }

  private renderOtherInstructorsChecklistFiles() {
    const { t } = this.props;
    const files = this.state.otherInstructorsChecklistFiles;
    if (files.length === 0) return null;

    return (
      <div className="checklist-container__files-list checklist-container__files-list--readonly">
        <p className="checklist-container__files-title">{t('Other Files')}</p>
        {files.map(file => (
          <div key={file.id} className="checklist-item__uploaded-file-row">
            <Button
              basic
              icon="download"
              size="mini"
              title={t('Download')}
              onClick={() => this.downloadChecklistDocument(file.originalName, file.uploadedName, false, file.id)}
            />
            <span className="checklist-item__uploaded-file-name">{file.originalName}</span>
          </div>
        ))}
      </div>
    );
  }

  private load() {
    this.props.eventchecklistsroleuser.getAllAsync(this.state.query).then(res => {
      this.CheckData(res.items);
    });
  }

  private CheckData(items: eventCheckListRoleUserDto[]) {
    const event = this.props.eventFormStore.state.item;
    const currentUserInfo = this.identityService.getUserInfo();

    if (this.props.eventchecklistsroleuser.state.items && items.length > 0) {
      this.props.changeeventchecklistsroleuser.change({
        id: items[0].id,
        eventId: items[0].eventId,
        userId: IdentityService.isPoc(currentUserInfo) ? '' : currentUserInfo.userId,
        locationId: items[0].locationId,
        role: currentUserInfo.activeRole,
        roleUserChecks: this.hydrateChecks(items[0].roleUserChecks).filter(check => !check.isCheckListNew)
      });
      this.setState({ isUpdate: true });
    } else {
      let checks: eventCheckListRoleUserCheck[];
      checks = [];
      const filterByRole = event.checkLists.filter(c => {
        if (!c.checkListConfig) return false;
        if (c.isCheckListNew) return false;
        if (IdentityService.isAdmin(currentUserInfo)) return c.checkListConfig.rolesThatCreateCheckLists;
        return c.checkListConfig.rolesThatCreateCheckLists.includes(currentUserInfo.activeRole);
      });

      filterByRole.forEach(c => {
        checks.push({
          description: c.description,
          checked: false,
          comment: '',
          isMandatory: c.isMandatory ?? false,
          checkListId: c.id,
          isCheckListNew: c.isCheckListNew ?? false
        });
      });

      this.props.neweventchecklistsroleuser.createNew({
        eventId: event.id,
        userId: IdentityService.isPoc(currentUserInfo) || IdentityService.isPlanner(currentUserInfo) ? '' : currentUserInfo.userId,
        locationId: this.state.roleLocation,
        role: currentUserInfo.activeRole,
        roleUserChecks: checks
      });
      this.setState({ isUpdate: false });
    }
  }

  private async loadInstructorCheckLists() {
    const event = this.props.eventFormStore.state.item;
    const currentUser = this.identityService.getUserInfo();
    const instructors = event.instructors || [];
    const canManageInstructorCheckLists = IdentityService.isAdmin(currentUser) || IdentityService.isInstructor(currentUser);

    if (!canManageInstructorCheckLists || instructors.length === 0) return;

    const selectedInstructorId = IdentityService.isInstructor(currentUser) ? currentUser.userId : instructors[0].user?.id;
    const query: Query = {
      searchQuery: '',
      orderBy: [],
      skip: 0,
      take: 100000,
      filter: [{ EventId: { eq: { type: 'guid', value: event.id } } }],
      parameters: { ShowDeleted: 'false' }
    };

    this.setState({ loading: true });
    try {
      const result = await this.props.eventchecklistsroleusernew.getAllAsync(query);
      const groups = result.items || [];
      this.setState({ instructorCheckListGroups: groups, savedInstructorCheckListGroups: groups, selectedInstructorId, loading: false });
    } catch {
      this.setState({ loading: false });
    }
  }

  // The event configuration is the source of truth: persisted checks may not carry isCheckListNew.
  private hydrateChecks(checks: eventCheckListRoleUserCheck[]): eventCheckListRoleUserCheck[] {
    const configuredCheckLists = this.props.eventFormStore.state.item.checkLists || [];
    const normalize = (value: string) => (value || '').trim().toLowerCase();

    return (checks || []).map(c => {
      const config = configuredCheckLists.find(
        x => (c.checkListId && x.id === c.checkListId) || normalize(x.description) === normalize(c.description)
      );
      return {
        ...c,
        checkListId: config?.id ?? c.checkListId,
        isCheckListNew: config ? config.isCheckListNew ?? false : c.isCheckListNew ?? false
      };
    });
  }

  private getChecks(isCheckListNew: boolean): Array<{ check: eventCheckListRoleUserCheck; index: number }> {
    const store = this.state.isUpdate ? this.props.changeeventchecklistsroleuser : this.props.neweventchecklistsroleuser;
    const checks = store.state.item?.roleUserChecks || [];
    return checks.map((check, index) => ({ check, index })).filter(x => (x.check.isCheckListNew ?? false) === isCheckListNew);
  }

  private getSelectedInstructorCheckLists(): InstructorCheckListViewModel[] {
    const event = this.props.eventFormStore.state.item;
    const group = this.state.instructorCheckListGroups.find(x => x.userId === this.state.selectedInstructorId);
    const savedByCheckListId = new Map((group?.items || []).map(item => [item.checkListId, item]));

    return (event.checkLists || [])
      .filter(checkList => checkList.isCheckListNew && checkList.checkListConfig?.rolesThatCreateCheckLists.includes('Instructor'))
      .map(checkList => {
        const saved = savedByCheckListId.get(checkList.id);
        return {
          id: saved?.id ?? null,
          checkListId: checkList.id,
          checked: saved?.checked ?? false,
          comment: saved?.comment ?? null,
          description: checkList.description,
          isMandatory: (checkList as any).isMandatory ?? false
        };
      });
  }

  private isInstructorCheckListItemDirty(check: InstructorCheckListViewModel): boolean {
    const savedItem = this.state.savedInstructorCheckListGroups
      .find(group => group.userId === this.state.selectedInstructorId && group.role?.toLowerCase() === 'instructor')
      ?.items.find(item => item.checkListId === check.checkListId);

    if (!savedItem) return Boolean(check.checked || check.comment?.trim());

    return savedItem.checked !== check.checked || (savedItem.comment || '').trim() !== (check.comment || '').trim();
  }

  private upsertInstructorCheckListItem(
    groups: EventCheckListRoleUserNewGroupDto[],
    instructorId: string,
    item: EventCheckListRoleUserNewItemDto
  ): EventCheckListRoleUserNewGroupDto[] {
    const existingGroup = groups.find(group => group.userId === instructorId && group.role?.toLowerCase() === 'instructor');
    if (!existingGroup) {
      return [
        ...groups,
        {
          eventId: this.props.eventFormStore.state.item.id,
          role: 'Instructor',
          userId: instructorId,
          locationId: null,
          items: [item]
        }
      ];
    }

    const hasItem = existingGroup.items.some(existingItem => existingItem.checkListId === item.checkListId);
    return groups.map(group =>
      group === existingGroup
        ? {
            ...group,
            items: hasItem
              ? group.items.map(existingItem => (existingItem.checkListId === item.checkListId ? item : existingItem))
              : [...group.items, item]
          }
        : group
    );
  }

  private changeInstructorCheckListItem(checkListId: string, changes: Partial<EventCheckListRoleUserNewItemDto>) {
    const event = this.props.eventFormStore.state.item;
    const instructorId = this.state.selectedInstructorId;
    if (!instructorId) return;

    const viewItems = this.getSelectedInstructorCheckLists();
    const items = viewItems.map(({ description, isMandatory, ...item }) =>
      item.checkListId === checkListId ? { ...item, ...changes } : item
    );
    const group: EventCheckListRoleUserNewGroupDto = {
      eventId: event.id,
      role: 'Instructor',
      userId: instructorId,
      locationId: null,
      items
    };
    const groups = this.state.instructorCheckListGroups.filter(item => item.userId !== instructorId).concat(group);
    const modifiedInstructorIds = new Set(this.state.modifiedInstructorIds);
    modifiedInstructorIds.add(instructorId);
    this.setState({ instructorCheckListGroups: groups, modifiedInstructorIds, showSaveInstructorCheckListButton: true });
  }

  // comment is mandatory when the item is flagged as mandatory or left incomplete (unchecked)
  private isInstructorCommentMissing = (check: { checked: boolean; comment: string | null; isMandatory: boolean }) =>
    (check.isMandatory || !check.checked) && (!check.comment || !check.comment.trim());

  private onSaveInstructorChecklistItem = async (checkListId: string) => {
    const { t } = this.props;
    const check = this.getSelectedInstructorCheckLists().find(x => x.checkListId === checkListId);
    const instructorId = this.state.selectedInstructorId;
    if (check && this.isInstructorCommentMissing(check)) {
      ToastComponent({ text: t('Comment is required for incomplete checklist items'), type: 'warning-toast' });
      return;
    }
    if (!check || !instructorId) return;

    const currentItem = this.state.instructorCheckListGroups
      .find(group => group.userId === instructorId)
      ?.items.find(item => item.checkListId === checkListId);
    const itemId = currentItem?.id ?? check.id;

    const request: UpdateEventCheckListRoleUserNewItemDto = {
      eventId: this.props.eventFormStore.state.item.id,
      checkListId: check.checkListId,
      role: 'Instructor',
      userId: instructorId,
      locationId: null,
      checked: check.checked,
      comment: check.comment
    };
    if (itemId) request.id = itemId;

    this.setState({ loading: true });
    try {
      const response = await this.eventService.updateInstructorCheckListItem(request);
      if (response.data.isSuccess) {
        const savedItem = { ...check, ...(response.data.item || {}) };
        if (savedItem.checkListId !== checkListId) {
          this.setState({ loading: false });
          ToastComponent({ text: t('The saved checklist item does not match the requested item'), type: 'warning-toast' });
          return;
        }
        this.setState({
          instructorCheckListGroups: this.upsertInstructorCheckListItem(this.state.instructorCheckListGroups, instructorId, savedItem),
          savedInstructorCheckListGroups: this.upsertInstructorCheckListItem(
            this.state.savedInstructorCheckListGroups,
            instructorId,
            savedItem
          ),
          loading: false
        });
      } else {
        this.setState({ loading: false });
      }
    } catch {
      this.setState({ loading: false });
    }
  };

  private onSaveInstructorCheckList = async () => {
    const groups = this.state.instructorCheckListGroups.filter(group => this.state.modifiedInstructorIds.has(group.userId));
    if (groups.length === 0) return;

    this.setState({ loading: true });
    try {
      const response = await this.eventService.updateInstructorCheckListsBatch({
        eventId: this.props.eventFormStore.state.item.id,
        groups
      });
      if (response.data.isSuccess) {
        const savedGroups = response.data.item?.groups || [];
        const savedInstructorIds = new Set(savedGroups.map(group => group.userId));
        const instructorCheckListGroups = this.state.instructorCheckListGroups
          .filter(group => !savedInstructorIds.has(group.userId))
          .concat(savedGroups);
        this.setState({
          instructorCheckListGroups,
          savedInstructorCheckListGroups: instructorCheckListGroups,
          modifiedInstructorIds: new Set(),
          showSaveInstructorCheckListButton: false,
          loading: false
        });
      } else {
        this.setState({ loading: false });
      }
    } catch {
      this.setState({ loading: false });
    }
  };

  private selectedFromChecksList(index: number): void {
    if (this.state.isUpdate) {
      const item = this.props.changeeventchecklistsroleuser.state.item;
      const check = item.roleUserChecks[index];
      check.checked = !check.checked;

      this.props.changeeventchecklistsroleuser.change(item);
    } else {
      const item = this.props.neweventchecklistsroleuser.state.item;
      const check = item.roleUserChecks[index];
      check.checked = !check.checked;

      this.props.neweventchecklistsroleuser.change(item);
    }
    this.setState({ showSaveCheckListButton: true });
  }

  private changePocLocationFilter() {
    const event = this.props.eventFormStore.state.item;
    let filter = '';

    if (!!this.state.roleLocation) {
      const searchQuery: string = "role eq 'PoC' and LocationId eq " + this.state.roleLocation + '  and EventId eq ' + event.id;
      filter = searchQuery;

      const query = Object.assign(this.state.query, { filter, skip: 0 });
      this.setState({ query }, () => this.load());
    }
  }

  private onSavecheckList = async () => {
    const { t } = this.props;
    const item = this.state.isUpdate
      ? this.props.changeeventchecklistsroleuser.state.item
      : this.props.neweventchecklistsroleuser.state.item;

    const missingMandatory = (item?.roleUserChecks || []).some(c => c.isMandatory && (!c.comment || !c.comment.trim()));
    if (missingMandatory) {
      ToastComponent({ text: t('Mandatory comments must be filled before saving'), type: 'warning-toast' });
      return;
    }

    this.setState({ loading: true });
    const result = this.state.isUpdate
      ? await this.props.changeeventchecklistsroleuser.update()
      : await this.props.neweventchecklistsroleuser.submit();

    if (result?.isSuccess) {
      this.setState({ loading: false, showSaveCheckListButton: false });
      if (this.state.isUpdate) this.props.changeeventchecklistsroleuser.clear();
      else this.props.neweventchecklistsroleuser.clear();
      return;
    }

    this.setState({ loading: false });
  };

  private renderCheckItemLegacy(check: eventCheckListRoleUserCheck, index: number) {
    return (
      <Checkbox
        disabled={this.isCheckEditable()}
        label={check.description}
        checked={check.checked}
        onChange={() => this.selectedFromChecksList(index)}
      />
    );
  }
  private renderLegacyChecklistItems(legacyChecks: Array<{ check: eventCheckListRoleUserCheck; index: number }>) {
    const { t } = this.props;
    return (
      <div id="event-checklist-legacy-items">
        {legacyChecks.map(({ check, index }) => (
          <Form.Field key={index}>{this.renderCheckItemLegacy(check, index)}</Form.Field>
        ))}
        {this.state.showSaveCheckListButton && (
          <Form.Field>
            <Button positive icon="save" labelPosition="right" content={t('Save Check List')} onClick={this.onSavecheckList} />
          </Form.Field>
        )}
      </div>
    );
  }

  private toggleComment = (index: number) => {
    const expanded = new Set(this.state.expandedItems);
    expanded.has(index) ? expanded.delete(index) : expanded.add(index);
    this.setState({ expandedItems: expanded });
  };

  private onCommentChange = (index: number, value: string) => {
    const store = this.state.isUpdate ? this.props.changeeventchecklistsroleuser : this.props.neweventchecklistsroleuser;
    const item = { ...store.state.item };
    item.roleUserChecks = [...item.roleUserChecks];
    item.roleUserChecks[index] = { ...item.roleUserChecks[index], comment: value };
    store.change(item);
    this.setState({ showSaveCheckListButton: true });
  };

  private renderCheckItem(check: eventCheckListRoleUserCheck, index: number) {
    const { t } = this.props;
    const isExpanded = this.state.expandedItems.has(index);
    const isDisabled = this.isCheckEditable();
    const templateFile = this.getTemplateFileFromEventCheckList(check.checkListId);

    return (
      <div className="checklist-item">
        <div className="checklist-item__row">
          <Checkbox
            disabled={isDisabled}
            label={
              <label>
                {check.description}
                {check.isMandatory && <span className="checklist-item__mandatory"> *</span>}
              </label>
            }
            checked={check.checked}
            onChange={() => this.selectedFromChecksList(index)}
          />
          <Icon
            name={isExpanded ? 'chevron up' : 'chevron down'}
            className="checklist-item__toggle"
            onClick={() => this.toggleComment(index)}
            title={t('Toggle comment')}
          />
          {templateFile && (
            <Icon
              name="download"
              className="checklist-item__toggle"
              title={t('Download Template')}
              onClick={() => this.downloadTemplateFile(templateFile)}
            />
          )}
        </div>
        {isExpanded && (
          <Form.Field>
            <textarea
              disabled={isDisabled}
              placeholder={t('Add comment...')}
              value={check.comment || ''}
              onChange={e => this.onCommentChange(index, e.target.value)}
              rows={2}
              style={{ width: '100%', marginTop: 4, resize: 'vertical' }}
            />
          </Form.Field>
        )}
      </div>
    );
  }

  private renderInstructorCheckItem(check: InstructorCheckListViewModel, index: number) {
    const { t } = this.props;
    const isDisabled = this.isCheckEditable();
    const isDirty = this.isInstructorCheckListItemDirty(check);
    const toggleKey = 100000 + index;
    const isExpanded = this.state.expandedItems.has(toggleKey);

    return (
      <div className="checklist-item">
        <div className="checklist-item__row">
          <Checkbox
            className="checklist-item__checkbox"
            disabled={isDisabled}
            label={
              <label>
                {check.description}
                {check.isMandatory && <span className="checklist-item__mandatory"> *</span>}
              </label>
            }
            checked={check.checked}
            onChange={() => this.changeInstructorCheckListItem(check.checkListId, { checked: !check.checked })}
          />
          <div className="checklist-item__actions">
            <Icon
              name={isExpanded ? 'chevron up' : 'chevron down'}
              className="checklist-item__toggle"
              title={t('Toggle comment')}
              onClick={() => this.toggleComment(toggleKey)}
            />
            {isDirty && (
              <Button
                type="button"
                icon="save"
                color="teal"
                size="mini"
                className="checklist-item__row-save"
                disabled={isDisabled || this.state.loading}
                title={t('Unsaved changes. Save checklist item')}
                aria-label={t('Save checklist item')}
                onClick={() => this.onSaveInstructorChecklistItem(check.checkListId)}
              />
            )}
          </div>
        </div>
        {isExpanded && (
          <div className="checklist-item__expanded">
            <Form.Field className="checklist-item__comment-field">
              <div className="checklist-item__comment-row">
                <textarea
                  disabled={isDisabled}
                  placeholder={t('Add comment...')}
                  value={check.comment || ''}
                  onChange={event => this.changeInstructorCheckListItem(check.checkListId, { comment: event.target.value })}
                  rows={2}
                />
              </div>
            </Form.Field>
          </div>
        )}
      </div>
    );
  }
  private onUploadEventCheckListFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { t } = this.props;
    const file = e?.target?.files?.[0];
    if (!file) return;
    if (this.state.eventChecklistFiles.length > 0 || this.state.uploadingEventChecklistFile) {
      (document.getElementById('checklist_event_file_upload') as HTMLInputElement).value = '';
      ToastComponent({ text: t('Only one file can be uploaded'), type: 'warning-toast' });
      return;
    }
    if (!isValidChecklistExcelFile(file)) {
      (document.getElementById('checklist_event_file_upload') as HTMLInputElement).value = '';
      ToastComponent({ text: t('Only Excel files (.xlsx, .xls) up to 5MB are allowed'), type: 'warning-toast' });
      return;
    }
    if (this.state.eventChecklistFiles.some(f => f.originalName.trim().toLowerCase() === file.name.trim().toLowerCase())) {
      (document.getElementById('checklist_event_file_upload') as HTMLInputElement).value = '';
      ToastComponent({ text: t('A file with the same name already exists'), type: 'warning-toast' });
      return;
    }

    const event = this.props.eventFormStore.state.item;
    const usr = this.identityService.getUserInfo();
    const fileOwner = this.getEventChecklistFileOwner();

    this.setState({ uploadingEventChecklistFile: true });
    uploadEventChecklistUserFile(file, {
      eventId: event.id,
      role: fileOwner.role,
      userName: usr.userName,
      locationId: null,
      eventTypeName: event.eventType?.name,
      friendlyEventId: event.friendlyId
    })
      .then(result => {
        if (result.data.isSuccess && result.data.item) {
          this.setState({
            eventChecklistFiles: [
              ...this.state.eventChecklistFiles,
              { id: undefined, originalName: file.name, uploadedName: result.data.item.uploadedFileName }
            ],
            removedEventChecklistFiles: this.state.removedEventChecklistFiles.filter(
              removed => removed.uploadedName !== result.data.item.uploadedFileName
            )
          });
          ToastComponent({ text: this.props.t('File uploaded successfully!'), type: 'success-toast' });
        } else {
          ToastComponent({ text: this.props.t('File upload failed'), type: 'error-toast' });
        }

        (document.getElementById('checklist_event_file_upload') as HTMLInputElement).value = '';
        this.setState({ uploadingEventChecklistFile: false });
      })
      .catch(() => {
        (document.getElementById('checklist_event_file_upload') as HTMLInputElement).value = '';
        this.setState({ uploadingEventChecklistFile: false });
        ToastComponent({ text: this.props.t('File upload failed'), type: 'error-toast' });
      });
  };

  private onRemoveEventChecklistFile = async (uploadedName: string) => {
    const file = this.state.eventChecklistFiles.find(item => item.uploadedName === uploadedName);
    if (!file) return;

    if (!file.id) {
      try {
        await ChecklistRoleUserFileService.deleteEventFile({ uploadedName: file.uploadedName });
        this.setState({
          eventChecklistFiles: this.state.eventChecklistFiles.filter(f => f.uploadedName !== uploadedName)
        });
      } catch {
        ToastComponent({ text: this.props.t('File delete failed'), type: 'error-toast' });
      }
      return;
    }

    this.setState({
      eventChecklistFiles: this.state.eventChecklistFiles.filter(f => f.uploadedName !== uploadedName),
      removedEventChecklistFiles: [...this.state.removedEventChecklistFiles, file]
    });
  };

  // true only when the current file list diverges from the last backend-confirmed list
  private hasEventChecklistFileChanges(): boolean {
    const current = [...this.state.eventChecklistFiles.map(f => f.uploadedName)].sort();
    const confirmed = [...this.state.confirmedEventChecklistFiles.map(f => f.uploadedName)].sort();
    return current.length !== confirmed.length || current.some((name, i) => name !== confirmed[i]);
  }

  private onSaveEventChecklistFiles = async () => {
    const { t } = this.props;
    const names = this.state.eventChecklistFiles.map(f => f.originalName.trim().toLowerCase());
    if (new Set(names).size !== names.length) {
      ToastComponent({ text: t('Files cannot have duplicate names'), type: 'warning-toast' });
      return;
    }

    const event = this.props.eventFormStore.state.item;
    const fileOwner = this.getEventChecklistFileOwner();

    try {
      const currentUploadedNames = new Set(this.state.eventChecklistFiles.map(file => file.uploadedName));
      const removedFiles = [
        ...this.state.removedEventChecklistFiles,
        ...this.state.confirmedEventChecklistFiles.filter(file => !currentUploadedNames.has(file.uploadedName))
      ].filter((file, index, files) => file.id && files.findIndex(item => item.uploadedName === file.uploadedName) === index);

      await Promise.all([
        ...this.state.eventChecklistFiles
          .filter(file => !file.id)
          .map(file =>
            ChecklistRoleUserFileService.createEventFile({
              eventId: event.id,
              role: fileOwner.role,
              userId: fileOwner.userId,
              locationId: null,
              originalName: file.originalName,
              uploadedName: file.uploadedName
            })
          ),
        ...removedFiles.map(file => ChecklistRoleUserFileService.deleteEventFile({ id: file.id }))
      ]);

      this.setState({ confirmedEventChecklistFiles: this.state.eventChecklistFiles, removedEventChecklistFiles: [] });
      await this.loadEventChecklistFiles();
      ToastComponent({ text: t('Files saved successfully!'), type: 'success-toast' });
    } catch {
      ToastComponent({ text: t('File save failed'), type: 'error-toast' });
    }
  };

  private getTemplateFileFromEventCheckList(checkListId?: string): ChecklistTemplateFileViewModel | null {
    if (!checkListId) return null;

    const eventCheckList = (this.props.eventFormStore.state.item.checkLists || []).find(item => item.id === checkListId);
    const templateFiles = eventCheckList?.templateFiles || [];

    return templateFiles.length > 0 ? templateFiles[0] : null;
  }

  private async downloadChecklistDocument(fileName: string, uploadedName: string, isTemplateFile: boolean, fileId?: string) {
    if (!uploadedName) return;

    try {
      if (!isTemplateFile && fileId) {
        await ChecklistRoleUserFileService.downloadEventFile(fileId, fileName);
        return;
      }

      const result = await downloadChecklistFileAs(fileName, uploadedName, isTemplateFile);
      if (result.data.isSuccess && result.data.item) {
        return;
      } else {
        ToastComponent({
          text: result.data.messages?.map(message => message.body).join(', ') || this.props.t('File download failed'),
          type: 'error-toast'
        });
      }
    } catch {
      ToastComponent({ text: this.props.t('File download failed'), type: 'error-toast' });
    }
  }

  private downloadTemplateFile(template: ChecklistTemplateFileViewModel) {
    const templateId = template?.uploadedName || template?.originalName;
    if (!templateId) return;
    this.downloadChecklistDocument(template.originalName, templateId, true);
  }

  private async testDownloadEventTypeTemplate() {
    const eventTypeId = this.props.eventFormStore.state.item.eventType?.id;
    const { eventTypeTemplate, templateEventTypeId, loadingEventTypeTemplate, downloadingEventTypeTemplate } = this.state;
    if (
      !eventTypeId ||
      eventTypeId !== templateEventTypeId ||
      !eventTypeTemplate?.uploadedName ||
      loadingEventTypeTemplate ||
      downloadingEventTypeTemplate
    )
      return;

    this.setState({ downloadingEventTypeTemplate: true });
    try {
      await this.props.eventTypeChecklistTemplateStore.downloadByEventTypeId(eventTypeId, eventTypeTemplate.originalName);
    } catch (error) {
      console.error('template download error', error);
      ToastComponent({ text: this.props.t('File download failed'), type: 'error-toast' });
    } finally {
      this.setState({ downloadingEventTypeTemplate: false });
    }
  }

  private isCheckEditable() {
    const event = this.props.eventFormStore.state.item;
    const status = event.status.toString();
    if (
      (status === 'Completed' || status === 'InProgress') &&
      (this.identityService.isInRole(Roles.Instructor) ||
        this.identityService.isInRole(Roles.PoC) ||
        event.eventCreatorId === this.identityService.getUserInfo().userId)
    ) {
      return false;
    } else {
      return true;
    }
  }

  private getEventRelatedLocationIds() {
    const event = this.props.eventFormStore.state.item;
    let result = [];
    if (event && event.eventDetails && event.eventDetails.location) {
      result.push(event.eventDetails.location.id);
    }

    if (event && event.requests.length > 0) {
      event.requests.forEach(req => result.push(req.requestingLocationId));
    }

    return result;
  }

  public render() {
    const { t } = this.props;
    const currentUserInfo = this.identityService.getUserInfo();
    const legacyChecks = this.getChecks(false);
    const instructorCheckLists = this.getSelectedInstructorCheckLists();
    const instructors = this.props.eventFormStore.state.item.instructors || [];
    const canManageInstructorCheckLists = IdentityService.isAdmin(currentUserInfo) || IdentityService.isInstructor(currentUserInfo);
    const showInstructorCheckLists = canManageInstructorCheckLists && instructors.length > 0 && instructorCheckLists.length > 0;
    return (
      <>
        {this.state.loading && (
          <div style={{ height: 200 }}>
            <Dimmer active inverted>
              <Loader size="large" active inverted />
            </Dimmer>
          </div>
        )}
        <Form className="events-form__check-list-container">
          {this.state.hasPocManyLocations && (
            <div style={{ marginBottom: 8 }}>
              <LocationEditorWithRoleLocations
                value={this.state.roleLocation}
                locationsReceived={currentUserInfo.locationsByRoles[currentUserInfo.activeRole].toArray<string>()}
                onChange={location => this.setState({ roleLocation: location ? location.id : null }, () => this.changePocLocationFilter())}
              />
            </div>
          )}

          {canManageInstructorCheckLists && instructors.length > 1 && (
            <div className="checklist-header">
              <p className="checklist-header__instructor">{t("Instructor's Name")}</p>
              <Dropdown
                id="checklist-instructor"
                selection
                className="checklist-header__dropdown"
                value={this.state.selectedInstructorId}
                disabled={!IdentityService.isAdmin(currentUserInfo) || instructors.length <= 1}
                options={instructors.map(instructor => ({
                  key: instructor.user?.id,
                  value: instructor.user?.id,
                  text: `${instructor.user?.firstName || ''} ${instructor.user?.lastName || ''}`.trim()
                }))}
                onChange={(_, data) => {
                  const instructorId = data.value as string;
                  if (instructorId === this.state.selectedInstructorId) return;
                  if (this.hasEventChecklistFileChanges()) {
                    ToastComponent({ text: t('Save or cancel file changes before changing instructor'), type: 'warning-toast' });
                    return;
                  }
                  this.setState({ selectedInstructorId: instructorId }, () => {
                    this.loadEventChecklistFiles(instructorId);
                    this.loadOtherInstructorsChecklistFiles(instructorId);
                  });
                }}
              />
            </div>
          )}

          {canManageInstructorCheckLists && instructors.length > 0 && instructorCheckLists.length > 0 && (
            <div className="checklist-container">
              <div className="checklist-container__left">
                {instructorCheckLists.map((check, index) => (
                  <Form.Field key={check.checkListId}>{this.renderInstructorCheckItem(check, index)}</Form.Field>
                ))}
              </div>

              <div className="checklist-container__right">
                <div className="checklist-container__right-buttons">
                  <Button
                    icon="upload"
                    content={t('Upload file')}
                    className="checklist-item__white-action"
                    disabled={this.isCheckEditable() || this.state.eventChecklistFiles.length > 0 || this.state.uploadingEventChecklistFile}
                    onClick={() => document.getElementById('checklist_event_file_upload')?.click()}
                  />
                  <Button
                    icon="download"
                    content={t('Download template')}
                    className="checklist-item__white-action"
                    disabled={
                      this.state.loadingEventTypeTemplate ||
                      this.state.downloadingEventTypeTemplate ||
                      this.state.templateEventTypeId !== this.props.eventFormStore.state.item.eventType?.id ||
                      !this.state.eventTypeTemplate?.uploadedName
                    }
                    onClick={() => this.testDownloadEventTypeTemplate()}
                  />
                </div>
                {this.state.eventChecklistFiles.length > 0 && (
                  <div className="checklist-container__files-list">
                    {this.state.eventChecklistFiles.map(file => (
                      <div key={file.uploadedName} className="checklist-item__uploaded-file-row">
                        <Button
                          basic
                          icon="download"
                          size="mini"
                          onClick={() => this.downloadChecklistDocument(file.originalName, file.uploadedName, false, file.id)}
                        />
                        <span className="checklist-item__uploaded-file-name">{file.originalName}</span>
                        <Button
                          basic
                          icon="remove"
                          size="mini"
                          color="red"
                          disabled={this.isCheckEditable()}
                          onClick={() => this.onRemoveEventChecklistFile(file.uploadedName)}
                        />
                      </div>
                    ))}
                  </div>
                )}
                {this.hasEventChecklistFileChanges() && (
                  <Button
                    positive
                    icon="save"
                    labelPosition="right"
                    content={t('Save file changes')}
                    onClick={this.onSaveEventChecklistFiles}
                  />
                )}
                {this.renderOtherInstructorsChecklistFiles()}
              </div>
            </div>
          )}

          {legacyChecks.length > 0 && (
            <div className="checklist-section">
              {showInstructorCheckLists ? (
                <>
                  <Divider />
                  <button
                    type="button"
                    className="checklist-section-toggle checklist-section-toggle--event"
                    aria-expanded={this.state.showLegacyCheckList}
                    aria-controls="event-checklist-legacy-items"
                    onClick={() => this.setState({ showLegacyCheckList: !this.state.showLegacyCheckList })}
                  >
                    <span>{t('Checklist for role {{roleName}}', { roleName: currentUserInfo.activeRole })}</span>
                    <Icon name={this.state.showLegacyCheckList ? 'chevron up' : 'chevron down'} />
                  </button>
                  {this.state.showLegacyCheckList && this.renderLegacyChecklistItems(legacyChecks)}
                </>
              ) : (
                this.renderLegacyChecklistItems(legacyChecks)
              )}
            </div>
          )}

          <input hidden id="checklist_event_file_upload" type="file" accept=".xlsx,.xls" onChange={this.onUploadEventCheckListFile} />
        </Form>
      </>
    );
  }
}
export default withTranslation()(CheckListTabPane);
